import saveQuoteMetadata from 'core/services/saveQuoteMetadata'
import { IS_AGENT } from 'core/constants/environment'
import { forMultiCarrier } from './for-multi-carrier'
import {
  getState,
  createLink,
  getBaseParameters,
  urlQueryParameters,
  contactParameters,
  primaryMemberParameters,
  planParameters
} from './mixins'

const createAndSaveQuoteMetadata = placementUrl => storeRef => {
  if (!IS_AGENT) {
    return storeRef
  }

  const state = getState(storeRef)
  const baseParameters = getBaseParameters(state)

  const metaData = {
    ...baseParameters,
    isMulticarrier: forMultiCarrier(state),
    link: createLink(state, placementUrl, baseParameters.agentId),
    // The order to spread the objects is important to define the priority of the data
    ...urlQueryParameters(),
    ...contactParameters(state),
    ...primaryMemberParameters(state),
    ...planParameters(state)
  }

  saveQuoteMetadata(metaData).catch(error =>
    console.error('[X] Error saving quote metadata', error)
  )

  return storeRef
}

export default createAndSaveQuoteMetadata
